import { Table } from "react-bootstrap";
import Loader from "react-loader-spinner";
import { Fragment, useEffect, useRef } from "react";
import { useParams } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { Tab, TabList, TabPanel, Tabs } from "react-tabs";
import { getAllProvinces } from "../store/api/LocationAPI";
import ModalSelectStaff from "../Components/ModalSelectStaff";
import { Download, Trash, Upload } from "react-bootstrap-icons";
import { getSystemSettings } from "../store/api/SystemSettingsAPI";
import CustomerEvents from "../Components/Customer/CustomerEvents";
import PreCustomerInfo from "../Components/Customer/PreCustomerInfo";
import PreCustomerProduct from "../Components/Customer/PreCustomerProduct";
import { attachFile, deleteAttachment, downloadFile } from "../../store/api/CommonFunctions";
import { getAttachmentList, getPreCustomerBaseInfoes, getCustomerEvents, getEventTypeList, getPreCutomer, getPreCustomerProductList } from "../store/api/CustomerApi";
import { isWebApp } from "../../store/api/CommonFunctions";
import CustomerCallHistory from "../Components/Customer/CustomerCallHistory";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faIdCard } from "@fortawesome/free-solid-svg-icons";

const AddEditPreCustomer = () => {
    const { id } = useParams();
    const attachInput = useRef();
    const dispatch = useDispatch();
    const settingNames = ['ProductGrouppingType', 'NationalCodeIsRequired', 'TaxPercent'];
    const attachList = useSelector(state => state.customerDataReducer.attachmentList);
    const relatedCustomerID = useSelector(state => state.customerDataReducer.preCustomer?.RelatedCustomerID)
    const onSelectTab = (index) => {
        if (index === 1) {
            let searchData = {};
            searchData.Skip = 0;
            searchData.CustomerID = id;
            searchData.Take = 10;
            searchData.IsPreCustomer = true;
            searchData.IsStaff = false;
            dispatch(getCustomerEvents(searchData));

        }
        else if (index === 2) {
            dispatch(getAttachmentList(id, "PreCustomerAttachment"));
        }
        else if (index === 3) {
            dispatch(getPreCustomerProductList(id, true));
        }
    }
    const attach = () => {
        dispatch(attachFile(attachInput.current, id, "PreCustomerAttachment", () => { dispatch(getAttachmentList(id, "PreCustomerAttachment")) }));
    }
    const deleteAttach = (attachID) => {
        dispatch(deleteAttachment(attachID, "PreCustomerAttachment", () => { dispatch(getAttachmentList(id, "PreCustomerAttachment")) }));
    }
    useEffect(() => {
        document.body.classList = "notMain";
        document.title = "بی همتا-مشتریان";
        dispatch(getSystemSettings(settingNames));
        dispatch(getAllProvinces());
        dispatch(getPreCustomerBaseInfoes());
        dispatch(getEventTypeList());
    }, [])

    return (
        <div className="container-fluid mt-2">
            <br />
            <div className="card">
                <div className="card-header headerStyle">
                    <FontAwesomeIcon icon={faIdCard} size="lg"/>&nbsp;
                    اطلاعات مشتری بالقوه</div>
                <div className="card-body bodyStyle" style={{ textAlign: "right" }}>
                    <ModalSelectStaff />
                    <Tabs onSelect={index => onSelectTab(index)}>
                        <TabList>
                            <Tab>
                                اطلاعات مشتری بالقوه
                            </Tab>
                            <Tab disabled={!(Number(id) > 0) || Number(relatedCustomerID) > 0}>
                                رویدادها
                            </Tab>
                            <Tab disabled={!(Number(id) > 0) || Number(relatedCustomerID) > 0}>
                                پیوست ها
                            </Tab>
                            {isWebApp() &&
                                <Fragment>
                                    <Tab disabled={!(Number(id) > 0)}>
                                        محصولات درخواستی
                                    </Tab>
                                    <Tab disabled={!(Number(id) > 0)}>
                                        تاریخچه تماس ها
                                    </Tab>
                                </Fragment>
                            }
                        </TabList>
                        <TabPanel>
                            <PreCustomerInfo id={id} />
                        </TabPanel>
                        <TabPanel >
                            <CustomerEvents customerID={id} isPreCustomer={true} />
                        </TabPanel>
                        <TabPanel>
                            <div className="form-group col-md-5">
                                <input ref={attachInput} className='form-control' style={{ display: "inline-block", maxWidth: "70%" }} type="file"></input>
                                <button type="button" className="btn btn-primary btn-block group-Btn" onClick={attach}><Upload size={18} /></button>
                            </div>
                            <Table className="mt-3">
                                <thead>
                                    <tr>
                                        <th style={{ display: "none" }}></th>
                                        <th style={{ width: window.innerWidth > 414 ? "25%" : "20%", paddingRight: "2px" }}>تاریخ پیوست</th>
                                        <th style={{ paddingRight: "5px", width: window.innerWidth > 414 ? "70%" : "55%" }}>نام فایل</th>
                                        <th style={{ paddingRight: "5px", width: window.innerWidth > 414 ? "5%" : "20%" }}> </th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {attachList === "PENDING" &&
                                        <tr>
                                            <td colSpan={4} style={{ textAlign: "center" }}>
                                                <Loader type="BallTriangle" color="#bb1370" height={30} width={30} />
                                            </td>
                                        </tr>}
                                    {attachList && Array.isArray(attachList) && attachList.map((item, i) => {
                                        return (
                                            <tr key={i} className="resultTableRow">
                                                <td style={{ display: "none" }}></td>
                                                <td>{item.PAttachDate}</td>
                                                <td>{item.AttachFileName}</td>
                                                <td>
                                                    <Download size={18} style={{ color: 'green' }}
                                                        onClick={() => {
                                                            downloadFile(item.ID, "PreCustomerAttachment");
                                                        }} />
                                                    &nbsp;
                                                    <Trash size={18} style={{ color: 'red' }}
                                                        onClick={() => {
                                                            deleteAttach(item.ID)
                                                        }}
                                                    />
                                                </td>
                                            </tr>)
                                    })
                                    }
                                </tbody>
                            </Table>
                        </TabPanel>
                        {isWebApp() &&
                            <Fragment>
                                <TabPanel>
                                    <PreCustomerProduct preCustomerID={id} customerID={relatedCustomerID} isPreCustomer={true} />
                                </TabPanel>
                                <TabPanel>
                                    <CustomerCallHistory customerID={id} callerType="precustomer" />
                                </TabPanel>
                            </Fragment>
                        }
                    </Tabs>

                </div>
            </div>
        </div>
    )
}
export default AddEditPreCustomer;